import React, { useEffect, useState } from 'react'
import Page from '../../common/Page'
import $t from '../../../i18n'
import { useDispatch, useSelector } from 'react-redux'
import Actions from '../../../actions'
import { capitalizeFirstLetter, capitalizeFirstLetterEachWord } from 'consts'
import EmptyList from '../../common/EmptyList'
import CardListItem from '../../common/CardListItem/CardListItem'
import {
  getClaimFormattedDate,
  formattedClaimId,
  getClaimStatusByCode
} from 'utils/claims'
import { event, eventTypes } from 'consts/eventConsts'
import Alert from '../../common/Alert'
import { CARD_LIST_ITEM_IMAGE } from 'consts/CardListItemConsts'
import { CLAIM_TYPE } from 'consts/ClaimsConsts'
import { useRouteMatch } from 'react-router'
import './Claims.css'

const Claims = () => {
  const dispatch = useDispatch()

  const { isClaimsLoading, claims } = useSelector(state => state?.nhMember)
  const { selectedMember, members } = useSelector(state => state.account)
  const { userDetails } = useSelector(state => state.profile)
  const { url } = useRouteMatch()
  const getPatientIdByMemberId = memberId => {
    if (userDetails?.hmo_member_id === memberId) return userDetails?.id
    else return members?.find(member => member?.hmo_member_id === memberId)?.id
  }
  const [ssoRedirectAction, setSsoRedirectAction] = useState(null)

  const claimsByMember = selectedMember?.id
    ? claims?.filter(
        claim =>
          claim?.memberId.toString() ===
          selectedMember?.hmo_member_id.toString()
      )
    : claims

  const isNoClaims = !isClaimsLoading && !claimsByMember?.length

  useEffect(() => {
    dispatch(Actions.createAction(Actions.CLAIMS_REQUESTED))
  }, [dispatch])

  const handleSSO = () => {
    dispatch(
      Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
        type: eventTypes.click,
        eventName: event.clickEvent.click,
        element: 'Proceed SSO'
      })
    )

    // redirect to sso page if there is a redirect action
    if (!!ssoRedirectAction) {
      dispatch(Actions.createAction(ssoRedirectAction))
      setSsoRedirectAction(null)
    }
  }

  const onClaimPress = (claimId, memberId) => {
    dispatch(
      Actions.createAction(
        Actions.NAVIGATED_TO,
        `${url}/${claimId}?memberId=${memberId}`
      )
    )
  }
  return (
    <Page
      loading={isClaimsLoading}
      className='claims-page'
      title={$t('pages.claims.title')}
      fullWidth={true}
      hideAlertBanner={true}
      displayManageFamily
      manageFamilyProps={{
        isFamilyHidden: false,
        isNotEnsuredDisabled: true
      }}
    >
      {isNoClaims && <EmptyList title={$t('pages.claims.noClaims')} />}
      <div className='claim-card-list-items-container'>
        {!isNoClaims &&
          claimsByMember?.map((claim, index) => {
            return (
              <CardListItem
                key={claim?.claimId + index}
                dataName={'claim-item-' + claim?.claimId}
                patientId={getPatientIdByMemberId(claim?.memberId)}
                imageName={
                  claim.claimType === CLAIM_TYPE.MEDICAL
                    ? CARD_LIST_ITEM_IMAGE.PROVIDER
                    : CARD_LIST_ITEM_IMAGE.PHARMACY
                }
                issueDate={`${$t(
                  'pages.claims.serviceDate'
                )}: ${getClaimFormattedDate(claim?.dateOfService)}`}
                title={
                  capitalizeFirstLetterEachWord(claim?.providerName) ||
                  $t('pages.claims.providerName')
                }
                subtitle={capitalizeFirstLetter(`${claim?.claimType}
                  ${$t('pages.claims.claimNumber')}${formattedClaimId(
                  claim?.claimId
                )}`)}
                status={getClaimStatusByCode(claim?.claimStatusCode)}
                onCardClick={() =>
                  onClaimPress(claim?.claimId, claim?.memberId)
                }
              />
            )
          })}
      </div>
      <Alert
        title={$t('common.note')}
        className='redirect-alert'
        closable={true}
        shouldDisplay={!!ssoRedirectAction}
        onCancel={() => setSsoRedirectAction(null)}
        OkText={$t('common.proceed')}
        onOk={handleSSO}
      >
        {$t('pages.prescriptions.redirectTitlePopup')}
      </Alert>
    </Page>
  )
}

export default Claims
